/**
 * @description Asynchronously loads the CToast component
 */
export default defineAsyncComponent({
  loader: () => import('@/components/common/CToast/CToast.vue'),
  suspensible: false
})
